import React from 'react';
import { useCountries } from 'modules/geo';
import { useFormContext } from 'react-hook-form';
import { AutocompleteField } from 'components/form';

import { DealSheetRulesFilters } from './index';

export const Country = () => {
  const { control } = useFormContext<DealSheetRulesFilters>();

  const { countries, loading } = useCountries();

  return (
    <AutocompleteField
      multiple
      size="small"
      name="COUNTRY"
      loading={loading}
      control={control}
      options={countries}
      disableCloseOnSelect
      textFieldProps={{ variant: 'outlined', label: 'Country' }}
    />
  );
};
